import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "projects",
    pageTitle: "Projects",
    displayName: "Projects",
    columns,
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
